import styled from 'styled-components';
import { customBreakPoint } from '~/styles/break-points';

export const StyledContent = styled.div`
	margin-top: 1rem;
	display: flex;
	flex-direction: column;
	gap: 2rem;
	margin: auto;

	.filters--container {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;

		${customBreakPoint(
			350,
			`
			flex-direction: row;
			align-items: center;
			gap: 3rem;
		`,
		)}
	}

	.tile-container {
		display: flex;
		flex-direction: column;
		gap: 2rem;

		${customBreakPoint(
			600,
			`
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
			row-gap: 2rem;
			`,
		)}
		${customBreakPoint(
			768,
			`
				grid-template-columns: repeat(2, 1fr);
			`,
		)}
		 .not-found {
			max-width: 480px;
			display: flex;
			flex-direction: column;
			text-align: left;
			grid-column: span 2;

			ul {
				list-style: disc;
				margin-left: 1rem;
			}
		}

		.card-skeleton {
			width: 360px;
			height: 580px;
		}
		@media (max-width: 444px) {
			.card-skeleton {
				width: 100%;
			}
		}

		& > button {
			max-width: max-content;
			align-self: center;
		}
	}
`;

export const StyledMoreLink = styled.div`
	float: right;
`;
